var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgIconQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#CEDCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 36H36V52H41.3333V41.3333H52V36ZM36 84V68H41.3333V78.6667H52V84H36ZM68 36V41.3333H78.6667V52H84V36H68ZM78.6667 68H84V84H68V78.6667H78.6667V68ZM46.6667 46.6667H57.3333V57.3333H46.6667V46.6667ZM46.6667 62.6667H57.3333V73.3333H46.6667V62.6667ZM73.3333 46.6667H62.6667V57.3333H73.3333V46.6667ZM62.6667 62.6667H73.3333V73.3333H62.6667V62.6667Z",
    fill: "#4974D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIconQr);
export default __webpack_public_path__ + "static/media/img-icon-qr.d697e59feab8fcfec4b96511170d245b.svg";
export { ForwardRef as ReactComponent };